import { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import CheckoutForm from './CheckoutForm'

export const MealzoPaymentHandler = () => {
  let stripePromise = loadStripe('pk_live_e6XP4acxDCZiTpnfzrifBbNP006GDt1vHq')
  const [clientSecret, setClientSecret] = useState<string>('')

  useEffect(() => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    var secret = urlParams.get('secretKey')
    console.log('Secret:', secret)
    if (secret) {
      setClientSecret(secret)
    }
  }, [])

  // return (
  //   <>
  //     {clientSecret ? (
  //       <Elements stripe={stripePromise} options={{ clientSecret }}>
  //         <form id="payment-form">
  //           <PaymentElement id="payment-element" />
  //         </form>
  //       </Elements>
  //     ) : (
  //       <p>Loading payment...</p>
  //     )}
  //   </>
  // )

  return (
    <>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm />
        </Elements>
      )}
    </>
  )
}
